import {Grid} from "@mui/system";
import React from "react";
import style from "../../assets/css/home.module.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ReactStars from "react-stars";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import {Navigation, Keyboard} from "swiper/modules";
import {Swiper, SwiperSlide} from "swiper/react";

const testimonials = [
  {
    id: 1,
    text: "After experiencing a shipping loss, we were worried about a long claims process. However, Associated International Brokers, Inc worked swiftly with the underwriters, and we received payment within just three weeks of the loss occurrence. Their efficiency and professionalism gave us confidence that we were in the right hands.",
    name: "Alex P.",
    designation: "Luxury Watch Distributor",
    rating: 5,
  },
  {
    id: 2,
    text: "The level of personal attention we receive from Associated International Brokers, Inc is unmatched. Both Setu and Janak took the time to understand our specific needs, providing a customized policy that truly fits our business. Their deep industry knowledge and hands-on approach make all the difference.",
    name: "Rachel M.",
    designation: "High-End Jewelry Retailer",
    rating: 4.5,
  },
  {
    id: 3,
    text: "Our business moves fast, and when we needed an urgent coverage adjustment, Associated International Brokers, Inc approved our endorsement request within hours. Their prompt response allowed us to proceed with our deal without delays. It’s rare to find a brokerage that is this efficient and client-focused.",
    name: "Daniel K.",
    designation: "Precious Stones Wholesaler",
    rating: 5,
  },
];

function GoogleReview() {
  return (
    <>
      <section className={style.reviewSection}>
        <Grid container spacing={3} className="customeContainer">
          <Grid size={{xs: 12, lg: 12}}>
            <div className={style.titleMain}>
              <h2 style={{color: "#fff"}}> Relationship based on trust </h2>
              {/* <p style={{ color: '#fff' }}>
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                            </p> */}
            </div>
          </Grid>
          <Grid size={{xs: 12, lg: 12}} sx={{mt: 1}}>
            <Swiper
              loop={testimonials.length > 6} // assuming 6 is your threshold
              slidesPerView={1}
              slidesPerGroup={1}
              navigation={true}
              pagination={{clickable: true}}
              // mousewheel
              keyboard
              modules={[Navigation, Keyboard]}
              className="reviewSlider"
              breakpoints={{
                0: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                640: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 1,
                  spaceBetween: 30,
                },
                1024: {
                  slidesPerView: 2,
                  spaceBetween: 40,
                },
                1199: {
                  slidesPerView: 3,
                  spaceBetween: 40,
                },
              }}
            >
              {testimonials.map((testimonial, idx) => (
                <SwiperSlide key={idx}>
                  <div className={style.reviewboxBg}>
                    <div className={style.reviewboxContent}>
                      <ReactStars
                        className={style.reviewboxstar}
                        count={5}
                        value={testimonial.rating}
                        size={24}
                        edit={false}
                        color1="#dadada"
                        color2="#ffd700"
                      />
                      <p>
                        {testimonial?.text}
                        {/* {testimonial?.text?.slice(0, 130)}
                                                {testimonial?.text?.length > 130 ? '...' : ''}
                                                {testimonial?.text?.length > 130 && (
                                                    <Button onClick={() => window.open('/', '_blank')}>
                                                        Read More
                                                    </Button>
                                                )} */}
                      </p>
                      <h3>{testimonial.name}</h3>
                      <h4> {testimonial.designation}</h4>
                      {/* <img src={GoogleImg} alt="Google Review" /> */}
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </Grid>
        </Grid>
      </section>
    </>
  );
}

export default GoogleReview;
